import { ContentPage } from '../page-factory/content-page';
import { mahaShivratriPage } from '../pages/page-kumbh-2025.maha-shivratri';
import { getPageMeta } from '../pages/pages-types';

export const meta = () => getPageMeta(mahaShivratriPage);

export default function MahaShivratriPage() {
  return <ContentPage {...mahaShivratriPage} />;
}
